var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useHistory } from "react-router-dom";
import { BasicFormFormat } from "../../src/View/UI/FormFormat/FormFormat";
import PipelineForm, { getPipelineSaveRequest, } from "../../src/View/Presentational/Pipeline/PipelineForm";
import PipelineService from "../../src/Services/Pipeline.service";
import { AlertInfo } from "../../src/View/UI/StandardAlerts/StandardAlerts";
import { getPipelineEditRoute } from "../../src/View/Pages/Pipeline/PipelineRoutes";
import { getPipelinesAdminBasePath } from "../../src/View/Pages/Admin/Pipelines/AdminPipelinesRoutes";
const PipelinesCreate = () => {
    const history = useHistory();
    const submit = (form) => __awaiter(void 0, void 0, void 0, function* () {
        const createRequest = getPipelineSaveRequest(form);
        yield PipelineService.createPipelineWithStagesAndSchedule(createRequest).then((response) => {
            if (response) {
                history.push(getPipelineEditRoute(response.id));
                return Promise.resolve("Save completed successfully.");
            }
            return Promise.reject("There was a problem saving this pipeline");
        });
    });
    return (_jsxs("div", { className: "container-fluid pb-3 pt-3", children: [_jsx("div", { className: "title-block clearfix", children: _jsx("div", { className: "d-flex justify-content-between", children: _jsxs("h1", { className: "title", children: [_jsx("a", { href: getPipelinesAdminBasePath(), className: "text-decoration-none", title: "Back to pipelines", children: _jsx("span", { className: "fal fa-arrow-circle-left" }) }), " ", "New Pipeline"] }) }) }), _jsx(AlertInfo, { message: "Stages may be added after saving the pipeline." }), _jsx("div", { role: "main", children: _jsx(BasicFormFormat, { handleSubmit: submit, defaultValue: {
                        opportunity: {
                            automatedSchedule: {
                                isManual: true,
                            },
                        },
                    }, children: _jsx(PipelineForm, { setShouldShowSaveButton: () => true }) }) })] }));
};
export default PipelinesCreate;
